(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const form = document.getElementById("cart_form");
  form.addEventListener("submit", localCart.checkout);

  } catch(e) { console.error(e); }
})();
})();
